import controller from './accounts.controller';
import template from './accounts.html';
import './accounts.scss';
/**
 * @ngdoc component
 * @name accounts
 * @description
 * The accounts component of the app.
 *
 * @memberof account
 */
export default {
  /**
   * The controller class for the component.
   * @type {AccountsController}
   */
  controller,
  /**
   * The HTML template for the component.
   * @type {String}
   */
  template,
};



// WEBPACK FOOTER //
// ./src/frontend/modules/account/components/accounts/accounts.component.js